import useAssignmentData from "@app/data-hooks/use-assignment-data.ts";
import { Button, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import { useForm } from "@tanstack/react-form";
import { Dialog, QueryStatusRouter } from "bi-lib";

interface Props {
    open: boolean;
    assignmentId: number;
    phaseId?: number;
    onClose: () => void;
}

export default function AssignmentPhaseModal({ open, phaseId, onClose, assignmentId }: Props) {
    const { assignmentPhase, updateAssignmentPhase } = useAssignmentData({ phaseId: open ? phaseId : undefined });

    const form = useForm({
        defaultValues: {
            phaseCode: assignmentPhase.data?.phaseCode,
            phaseDescription: assignmentPhase.data?.phaseDescription,
        },
        onSubmit: async ({ value }) => {
            await updateAssignmentPhase.mutateAsync({
                phaseId,
                assignmentId,
                phaseCode: value.phaseCode,
                phaseDescription: value.phaseDescription,
            });
            handleClose();
        },
    });

    const handleClose = () => {
        form.reset();
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth={"sm"} fullWidth>
            <DialogTitle>{phaseId == undefined ? "Create" : "Edit"} Phase</DialogTitle>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    void form.handleSubmit();
                }}
            >
                <DialogContent>
                    <QueryStatusRouter queryHook={assignmentPhase}>
                        <Stack spacing={1}>
                            <form.Field name={"phaseCode"}>
                                {(field) => (
                                    <TextField
                                        label={"Phase Code"}
                                        value={field.state.value ?? ""}
                                        onChange={(e) => {
                                            field.handleChange(e.target.value);
                                        }}
                                    />
                                )}
                            </form.Field>
                            <form.Field name={"phaseDescription"}>
                                {(field) => (
                                    <TextField
                                        label={"Description"}
                                        value={field.state.value ?? ""}
                                        onChange={(e) => {
                                            field.handleChange(e.target.value);
                                        }}
                                    />
                                )}
                            </form.Field>
                        </Stack>
                    </QueryStatusRouter>
                </DialogContent>
                <DialogActions>
                    <Button variant={"outlined"} onClick={onClose}>
                        Close
                    </Button>
                    <Button type={"submit"} variant={"contained"}>
                        Save
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
